var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlatelet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 50,
    viewBox: "0 0 45 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b { fill: currentColor; }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.29,148.2.594,139.9A.428.428,0,0,0,0,140.3v1.649a1.37,1.37,0,0,0,.861,1.272l19.1,7.641a.428.428,0,0,0,.587-.4v-1.872A.428.428,0,0,0,20.29,148.2Z",
    transform: "translate(0 -127.892)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M48.317,21.4l19.038-8.016a.428.428,0,0,0,.015-.783L48.73,3.9a1.37,1.37,0,0,0-1.159,0L28.932,12.6a.428.428,0,0,0,.015.783L47.985,21.4A.428.428,0,0,0,48.317,21.4Z",
    transform: "translate(-26.229 -3.451)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M272,148.591v1.636a.428.428,0,0,0,.587.4l19.1-7.641a1.37,1.37,0,0,0,.861-1.272V140.3a.428.428,0,0,0-.594-.395l-19.7,8.293A.428.428,0,0,0,272,148.591Z",
    transform: "translate(-248.708 -127.892)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatelet);
export default __webpack_public_path__ + "static/media/platelet.760d487e52a51a2efefb598181e672d1.svg";
export { ForwardRef as ReactComponent };